module.exports = __webpack_public_path__ + "static/img/video5.be9f6571.png";